module.exports = __webpack_public_path__ + "img/zfb.642e870e.svg";